import React, { PureComponent } from "react";
import { connect } from "react-redux";
import Modal from "react-modal";

import { TTP_API_URL } from "Config";
import { resetPDFViewer } from "Actions";

const customStyles = {
  content: {
    top: "5%",
    left: "5%",
    bottom: "5%",
    right: "5%",
    //marginRight: "-50%",
    //transform: "translate(-50%, -50%)",
    backgroundColor: "#fff",
    border: "none",
    zIndex: 12,
    maxHeight: "100%",
    padding: 0,
    overflow: "none"
  }
};

class PDFViewer extends PureComponent {
  closeModal = () => {
    this.props.resetPDFViewer();
  };

  afterOpenModal = () => {};

  renderCloseButton() {
    //TODO refator
    return (
      <div className="rmodal__close pdf-close">
        <button className="close teste" onClick={this.closeModal} />
      </div>
    );
  }

  getPDFPathFromPPT(media) {
    const path = media.webPath.substring(0, media.webPath.lastIndexOf("/"));

    return `${path}/PDF/${media.id}.pdf`;
  }

  renderViewer() {
    const { media } = this.props;

    const webPath =
      media.docType === "PDF" ? media.webPath : this.getPDFPathFromPPT(media);

    const path = `${TTP_API_URL}/${webPath}`.trim();
    const iframeStyles = {
      width: "100%",
      height: "100%"
      //marginTop: "16px"
    };

    return (
      <iframe
        style={iframeStyles}
        title={media.title}
        src={`/pdf-viewer/web/viewer.html?file=${encodeURIComponent(path)}`}
      />
    );
  }

  render() {
    const { isOpen, media } = this.props;

    return (
      <Modal
        isOpen={isOpen}
        onAfterOpen={this.afterOpenModal}
        onRequestClose={this.closeModal}
        style={customStyles}
        contentLabel="PDF Viewer"
      >
        {this.renderCloseButton()}
        {media && this.renderViewer()}
      </Modal>
    );
  }
}

// Connected Component
const mapStateToProps = (state, ownProps) => ({
  isOpen: state.pdfViewer.isOpen,
  media: state.pdfViewer.media
});

const mapDispatchToProps = dispatch => ({
  resetPDFViewer: () => dispatch(resetPDFViewer())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PDFViewer);



// WEBPACK FOOTER //
// ./src/components/Reveal/PDFViewer/PDFViewer.js